import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M21.0001 9.33268H20.3334V7.99935C20.3334 6.15935 18.8401 4.66602 17.0001 4.66602C15.1601 4.66602 13.6667 6.15935 13.6667 7.99935V9.33268H13.0001C12.2667 9.33268 11.6667 9.93268 11.6667 10.666V17.3327C11.6667 18.066 12.2667 18.666 13.0001 18.666H21.0001C21.7334 18.666 22.3334 18.066 22.3334 17.3327V10.666C22.3334 9.93268 21.7334 9.33268 21.0001 9.33268ZM17.0001 15.3327C16.2667 15.3327 15.6667 14.7327 15.6667 13.9993C15.6667 13.266 16.2667 12.666 17.0001 12.666C17.7334 12.666 18.3334 13.266 18.3334 13.9993C18.3334 14.7327 17.7334 15.3327 17.0001 15.3327ZM19.0667 9.33268H14.9334V7.99935C14.9334 6.85935 15.8601 5.93268 17.0001 5.93268C18.1401 5.93268 19.0667 6.85935 19.0667 7.99935V9.33268Z" />
    <rect height="2" width="7" x="2" y="11" />
    <rect height="2" width="9" x="2" y="6" />
    <rect height="2" width="7" x="2" y="16" />
  </>,
  'PrivateNotes',
)
